<template>

  <div class="own-peps-button" v-on:click="buttonPressed" v-if="!isOwnPep">
    <img src="../img/btn_ownmessages.svg" width>
    <label>Add own messages</label>
  </div>
  <div v-else-if="!selectedPepPointId">

<div class="own-peps-info-box">
    <label v-if="!isDistance">Click on the route to leave a message!</label>
  </div>
  <div class="own-peps-button active" v-on:click="buttonPressed">
    <img src="../img/btn_done.svg" width>
    <label>Done</label>
  </div>


  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { store } from '../store/store';
import MapManager from '../helpers/mapManager';
export default {
  name: 'ownPepsButton',

  methods: {
    buttonPressed() {
    this.$store.dispatch('toggleOwnPeps')
    MapManager.changePepEditingEnabled()
},
   },
     computed: {
      ...mapGetters([
        'isOwnPep', 'selectedPepPointId', 'isDistance'
      ]),
     }
  }
</script>

<style lang="scss" scoped>

  @import '../styles/styles.scss';

  .own-peps-button {
cursor:pointer;
padding: 15px 20px;
background-color:$grey;
display:flex;
flex-direction:row;
justify-content:center;

border-radius:26px;
    label {
      color:$cyan;
    	font-size: $font-semiLargePlus;
      margin-left:5px;
      font-weight: bold;
      text-decoration: underline;
      cursor:pointer;

    }
    img {
      width: 26.12px;
      max-height: 26px;
      cursor:pointer;

    }



  }
  .own-peps-button.position {
    position: fixed;
bottom:72px;
left: 50%;
transform: translateX(-50%);
z-index:4000;

  }
   .own-peps-button.active {
      padding: 15px 90px;
      background-color:$cyan;
      label {
        color:white;
        margin-left:10px;
      }
    }

.own-peps-button-container {
position: fixed;
bottom:0px;
left: 50%;
transform: translateX(-50%);
z-index:4000;
display:flex;
flex-direction:column;
align-items:center;
}

.own-peps-info-box {
  background-color:white;
  padding: 15px 15px;
  border-radius: 20px 20px 0px 0px;
  margin-top:0px;
  text-align: center;

  label {
    font-size:$font-semiSemiLarge;
    font-weight: bold;
    color:$cyan;

  }
}




</style>
